import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LANGUAGES = {
    en: { name: 'English', flag: 'EN' },
    es: { name: 'Espanol', flag: 'ES' },
    fr: { name: 'Francais', flag: 'FR' },
    pt: { name: 'Portugues', flag: 'PT' },
    zh: { name: '中文', flag: '中' },
    vi: { name: 'Tieng Viet', flag: 'VI' },
};

const TRANSLATIONS = {
    en: {
        // Nav
        'nav.dashboard': 'Dashboard',
        'nav.creditRepair': 'Credit Repair',
        'nav.mortgage': 'Mortgage',
        'nav.marketplace': 'Marketplace',
        'nav.admin': 'Admin',
        'nav.crm': 'CRM',
        'nav.login': 'Log In',
        'nav.register': 'Register',
        'nav.logout': 'Log Out',
        // Landing
        'landing.hero': 'Your Path to Homeownership Starts Here',
        'landing.subtitle': 'Credit repair, owner financing, and mortgage solutions — all in one platform.',
        'landing.cta': 'Get Started',
        'landing.buyerCta': "I'm a Buyer",
        'landing.sellerCta': "I'm a Seller",
        // Common
        'common.save': 'Save',
        'common.cancel': 'Cancel',
        'common.submit': 'Submit',
        'common.search': 'Search',
        'common.filter': 'Filter',
        'common.loading': 'Loading...',
        'common.noResults': 'No results found',
        'common.viewAll': 'View All',
        'common.back': 'Back',
        'common.next': 'Next',
        'common.delete': 'Delete',
        'common.edit': 'Edit',
        // Credit Repair
        'cr.title': 'Credit Repair Program',
        'cr.enroll': 'Enroll Now',
        'cr.disputes': 'Disputes',
        'cr.education': 'Education',
        'cr.simulator': 'Simulator',
        'cr.overview': 'Overview',
        'cr.uploadReport': 'Upload Credit Report',
        'cr.payNow': 'Pay Now',
        // Marketplace
        'mp.title': 'Property Marketplace',
        'mp.listProperty': 'List Property',
        'mp.sendInquiry': 'Send Inquiry',
        'mp.ownerFinance': 'Owner Finance Available',
        // Mortgage
        'mt.title': 'Mortgage Center',
        'mt.lenders': 'Lenders',
        'mt.application': 'Application',
        'mt.submissions': 'Submissions',
        // Chatbot
        'chat.greeting': 'Hi! How can I help?',
        'chat.placeholder': 'Ask anything...',
    },
    es: {
        'nav.dashboard': 'Panel',
        'nav.creditRepair': 'Reparacion de Credito',
        'nav.mortgage': 'Hipoteca',
        'nav.marketplace': 'Mercado',
        'nav.admin': 'Administrador',
        'nav.crm': 'CRM',
        'nav.login': 'Iniciar Sesion',
        'nav.register': 'Registrarse',
        'nav.logout': 'Cerrar Sesion',
        'landing.hero': 'Tu Camino a la Propiedad Comienza Aqui',
        'landing.subtitle': 'Reparacion de credito, financiamiento del propietario y soluciones hipotecarias — todo en una plataforma.',
        'landing.cta': 'Comenzar',
        'landing.buyerCta': 'Soy Comprador',
        'landing.sellerCta': 'Soy Vendedor',
        'common.save': 'Guardar',
        'common.cancel': 'Cancelar',
        'common.submit': 'Enviar',
        'common.search': 'Buscar',
        'common.filter': 'Filtrar',
        'common.loading': 'Cargando...',
        'common.noResults': 'No se encontraron resultados',
        'common.viewAll': 'Ver Todo',
        'common.back': 'Atras',
        'common.next': 'Siguiente',
        'common.delete': 'Eliminar',
        'common.edit': 'Editar',
        'cr.title': 'Programa de Reparacion de Credito',
        'cr.enroll': 'Inscribirse Ahora',
        'cr.disputes': 'Disputas',
        'cr.education': 'Educacion',
        'cr.simulator': 'Simulador',
        'cr.overview': 'Resumen',
        'cr.uploadReport': 'Subir Reporte de Credito',
        'cr.payNow': 'Pagar Ahora',
        'mp.title': 'Mercado de Propiedades',
        'mp.listProperty': 'Publicar Propiedad',
        'mp.sendInquiry': 'Enviar Consulta',
        'mp.ownerFinance': 'Financiamiento del Propietario Disponible',
        'mt.title': 'Centro Hipotecario',
        'mt.lenders': 'Prestamistas',
        'mt.application': 'Solicitud',
        'mt.submissions': 'Envios',
        'chat.greeting': 'Hola! Como puedo ayudarte?',
        'chat.placeholder': 'Pregunta lo que quieras...',
    },
    fr: {
        'nav.dashboard': 'Tableau de bord',
        'nav.creditRepair': 'Reparation de credit',
        'nav.mortgage': 'Hypotheque',
        'nav.marketplace': 'Marche',
        'nav.admin': 'Admin',
        'nav.crm': 'CRM',
        'nav.login': 'Connexion',
        'nav.register': "S'inscrire",
        'nav.logout': 'Deconnexion',
        'landing.hero': 'Votre chemin vers la propriete commence ici',
        'landing.subtitle': 'Reparation de credit, financement proprietaire et solutions hypothecaires — tout sur une plateforme.',
        'landing.cta': 'Commencer',
        'landing.buyerCta': 'Je suis acheteur',
        'landing.sellerCta': 'Je suis vendeur',
        'common.save': 'Enregistrer', 'common.cancel': 'Annuler', 'common.submit': 'Soumettre',
        'common.search': 'Rechercher', 'common.filter': 'Filtrer', 'common.loading': 'Chargement...',
        'common.noResults': 'Aucun resultat', 'common.viewAll': 'Voir tout', 'common.back': 'Retour', 'common.next': 'Suivant',
        'common.delete': 'Supprimer', 'common.edit': 'Modifier',
        'cr.title': 'Programme de reparation de credit', 'cr.enroll': "S'inscrire maintenant",
        'cr.disputes': 'Litiges', 'cr.education': 'Education', 'cr.simulator': 'Simulateur', 'cr.overview': 'Apercu',
        'cr.uploadReport': 'Telecharger le rapport', 'cr.payNow': 'Payer maintenant',
        'mp.title': 'Marche immobilier', 'mp.listProperty': 'Publier une propriete', 'mp.sendInquiry': 'Envoyer une demande',
        'mp.ownerFinance': 'Financement proprietaire disponible',
        'mt.title': 'Centre hypothecaire', 'mt.lenders': 'Preteurs', 'mt.application': 'Demande', 'mt.submissions': 'Soumissions',
        'chat.greeting': 'Bonjour! Comment puis-je vous aider?', 'chat.placeholder': 'Posez votre question...',
    },
    pt: {
        'nav.dashboard': 'Painel', 'nav.creditRepair': 'Reparo de Credito', 'nav.mortgage': 'Hipoteca',
        'nav.marketplace': 'Mercado', 'nav.admin': 'Admin', 'nav.crm': 'CRM',
        'nav.login': 'Entrar', 'nav.register': 'Registrar', 'nav.logout': 'Sair',
        'landing.hero': 'Seu caminho para a casa propria comeca aqui',
        'landing.subtitle': 'Reparo de credito, financiamento do proprietario e solucoes hipotecarias — tudo em uma plataforma.',
        'landing.cta': 'Comecar', 'landing.buyerCta': 'Sou Comprador', 'landing.sellerCta': 'Sou Vendedor',
        'common.save': 'Salvar', 'common.cancel': 'Cancelar', 'common.submit': 'Enviar',
        'common.search': 'Buscar', 'common.filter': 'Filtrar', 'common.loading': 'Carregando...',
        'common.noResults': 'Nenhum resultado', 'common.viewAll': 'Ver Tudo', 'common.back': 'Voltar', 'common.next': 'Proximo',
        'common.delete': 'Excluir', 'common.edit': 'Editar',
        'cr.title': 'Programa de Reparo de Credito', 'cr.enroll': 'Inscreva-se Agora',
        'cr.disputes': 'Disputas', 'cr.education': 'Educacao', 'cr.simulator': 'Simulador', 'cr.overview': 'Visao Geral',
        'cr.uploadReport': 'Enviar Relatorio', 'cr.payNow': 'Pagar Agora',
        'mp.title': 'Mercado Imobiliario', 'mp.listProperty': 'Publicar Imovel', 'mp.sendInquiry': 'Enviar Consulta',
        'mp.ownerFinance': 'Financiamento do Proprietario',
        'mt.title': 'Centro Hipotecario', 'mt.lenders': 'Credores', 'mt.application': 'Aplicacao', 'mt.submissions': 'Envios',
        'chat.greeting': 'Oi! Como posso ajudar?', 'chat.placeholder': 'Pergunte qualquer coisa...',
    },
    zh: {
        'nav.dashboard': '控制面板', 'nav.creditRepair': '信用修复', 'nav.mortgage': '抵押贷款',
        'nav.marketplace': '市场', 'nav.admin': '管理员', 'nav.crm': '客户关系',
        'nav.login': '登录', 'nav.register': '注册', 'nav.logout': '退出',
        'landing.hero': '您的置业之路从这里开始',
        'landing.subtitle': '信用修复、业主融资和抵押贷款解决方案 — 一站式平台。',
        'landing.cta': '开始', 'landing.buyerCta': '我是买家', 'landing.sellerCta': '我是卖家',
        'common.save': '保存', 'common.cancel': '取消', 'common.submit': '提交',
        'common.search': '搜索', 'common.filter': '筛选', 'common.loading': '加载中...',
        'common.noResults': '没有结果', 'common.viewAll': '查看全部', 'common.back': '返回', 'common.next': '下一步',
        'common.delete': '删除', 'common.edit': '编辑',
        'cr.title': '信用修复计划', 'cr.enroll': '立即注册',
        'cr.disputes': '争议', 'cr.education': '教育', 'cr.simulator': '模拟器', 'cr.overview': '概览',
        'cr.uploadReport': '上传信用报告', 'cr.payNow': '立即支付',
        'mp.title': '房产市场', 'mp.listProperty': '发布房产', 'mp.sendInquiry': '发送询问',
        'mp.ownerFinance': '业主融资可用',
        'mt.title': '抵押贷款中心', 'mt.lenders': '贷方', 'mt.application': '申请', 'mt.submissions': '提交记录',
        'chat.greeting': '你好！有什么可以帮您？', 'chat.placeholder': '随便问...',
    },
    vi: {
        'nav.dashboard': 'Bang dieu khien', 'nav.creditRepair': 'Sua chua tin dung', 'nav.mortgage': 'The chap',
        'nav.marketplace': 'Thi truong', 'nav.admin': 'Quan tri', 'nav.crm': 'CRM',
        'nav.login': 'Dang nhap', 'nav.register': 'Dang ky', 'nav.logout': 'Dang xuat',
        'landing.hero': 'Con duong so huu nha cua ban bat dau tai day',
        'landing.subtitle': 'Sua chua tin dung, tai tro chu so huu va giai phap the chap — tat ca tren mot nen tang.',
        'landing.cta': 'Bat dau', 'landing.buyerCta': 'Toi la nguoi mua', 'landing.sellerCta': 'Toi la nguoi ban',
        'common.save': 'Luu', 'common.cancel': 'Huy', 'common.submit': 'Gui',
        'common.search': 'Tim kiem', 'common.filter': 'Loc', 'common.loading': 'Dang tai...',
        'common.noResults': 'Khong co ket qua', 'common.viewAll': 'Xem tat ca', 'common.back': 'Quay lai', 'common.next': 'Tiep',
        'common.delete': 'Xoa', 'common.edit': 'Sua',
        'cr.title': 'Chuong trinh sua chua tin dung', 'cr.enroll': 'Dang ky ngay',
        'cr.disputes': 'Tranh chap', 'cr.education': 'Giao duc', 'cr.simulator': 'Mo phong', 'cr.overview': 'Tong quan',
        'cr.uploadReport': 'Tai bao cao', 'cr.payNow': 'Thanh toan',
        'mp.title': 'Thi truong bat dong san', 'mp.listProperty': 'Dang bat dong san', 'mp.sendInquiry': 'Gui yeu cau',
        'mp.ownerFinance': 'Tai tro chu so huu',
        'mt.title': 'Trung tam the chap', 'mt.lenders': 'Nguoi cho vay', 'mt.application': 'Don', 'mt.submissions': 'Da gui',
        'chat.greeting': 'Xin chao! Toi co the giup gi?', 'chat.placeholder': 'Hoi bat cu dieu gi...',
    },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem('visionaire_lang') || 'en');

    const changeLang = useCallback((newLang) => {
        setLang(newLang);
        localStorage.setItem('visionaire_lang', newLang);
    }, []);

    const t = useCallback((key) => {
        return TRANSLATIONS[lang]?.[key] || TRANSLATIONS.en[key] || key;
    }, [lang]);

    return (
        <I18nContext.Provider value={{ lang, setLang: changeLang, t, languages: LANGUAGES }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error('useI18n must be used within I18nProvider');
    return ctx;
}

export function LanguageSwitcher({ variant = 'light' }) {
    const { lang, setLang, languages } = useI18n();
    const [open, setOpen] = useState(false);
    const isDark = variant === 'dark';

    return (
        <div className="relative" data-testid="language-switcher">
            <button onClick={() => setOpen(!open)}
                className={`px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors ${isDark ? 'text-zinc-300 hover:text-white hover:bg-white/10 border border-white/10' : 'text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 border border-zinc-200'}`}
                data-testid="lang-toggle">
                {languages[lang]?.flag || 'EN'}
            </button>
            {open && (
                <div className="absolute right-0 top-full mt-1 bg-white rounded-lg shadow-xl border border-zinc-200 py-1 z-50 min-w-[140px]">
                    {Object.entries(languages).map(([code, info]) => (
                        <button key={code} onClick={() => { setLang(code); setOpen(false); }}
                            className={`w-full text-left px-3 py-1.5 text-sm hover:bg-zinc-50 flex items-center gap-2 ${lang === code ? 'text-emerald-700 font-medium' : 'text-zinc-700'}`}
                            data-testid={`lang-${code}`}>
                            <span className="w-5 text-center text-xs font-bold">{info.flag}</span>
                            {info.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
